module.exports = __webpack_public_path__ + "img/logo.9d7a85cf.png";